import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

import FeedbackPopup from 'Components/Feedback/FeedbackPopups/FeedbackPopup';
import FeedbackPopupRedesign from 'Components/Feedback/FeedbackPopups/FeedbackPopupRedesign';
import useViewport from 'Hooks/useViewport';

import 'Components/Feedback/FeedbackPopups/FeedbackPopups.scss';
import 'Components/Feedback/FeedbackPopups/FeedbackPopupRedesign.scss';

const FeedbackPopupContainer = ({ feedbackPopups }) => {
  const { isBelowMd } = useViewport();
  if (isEmpty(feedbackPopups)) return false;

  const showRedesign = isBelowMd;

  return (
    <div className={classNames({ 'popups-container': !showRedesign }, { 'popups-container-redesign': showRedesign })}>
      {feedbackPopups.map(feedback =>
        <React.Fragment key={feedback.id}>
          {showRedesign ?
            <FeedbackPopupRedesign feedback={feedback} /> :
            <FeedbackPopup feedback={feedback} />
          }
        </React.Fragment>,
      )}
    </div>
  );
};

FeedbackPopupContainer.propTypes = {
  feedbackPopups: PropTypes.arrayOf(PropTypes.object),
};

FeedbackPopupContainer.defaultProps = {
  feedbackPopups: [],
};

const mapStateToProps = ({ feedbackPopups }) => ({ feedbackPopups });

export default connect(mapStateToProps)(FeedbackPopupContainer);
